<template>
    <div>
      <Teleport to="#settings-group-header">
        <T>Настройка Доставки</T>
        <div style="font-size: 0.85rem; color: gray;"><T>Только для магазина</T></div>
      </Teleport>  
  
      <Teleport to="#settings-group-actions">
        <v-btn test-tag="tag-276"
          text
          color="primary"
          @click="save"
          :loading="loading"
          :disabled="dis"
        >
          <v-icon>mdi-content-save</v-icon>
          <T>Сохранить</T>
        </v-btn>
      </Teleport>
      
      <Rules :loading="loading" :config="$store.getters.local_refs.rules_delivery" ref="form" @configChanged="onConfigChanged"/>
    </div>
  </template>
  
  <script>
  
  import Teleport from 'vue2-teleport'
  import Rules from '../../components/settings/rules'
  
  
  export default {
    data: () => ({
      loading: false,
      dis: false
    }),
    methods: {
      isSaveDisabled() {
        const cfg = this.current_config
        const paymentsDisabled = !cfg.allow_pay_cash && !cfg.allow_pay_card_offline && !cfg.allow_pay_card_online
        const deliveryDisabled = !cfg.allow_delivery && !cfg.allow_pickup
        return paymentsDisabled || deliveryDisabled
      },
      async save(){
        this.loading = true
        try {
          let new_config = {rules_delivery: this.$refs.form.submit()}
          
          await this.$store.dispatch('updateLocalRefs', new_config)
  
          this.$store.dispatch('throwTimeoutMessage', {
            message_data: this.$t('Изменения сохранены'),
            message_class: 'success'
          })
  
        } catch (e) {
          this.$store.dispatch('throwTimeoutMessage', {
            message_data: `${e.message}`,
            message_class: 'error'
          })
          this.loading = false
        } finally {
          this.loading = false
        }
      },
      onConfigChanged(config) {
        this.current_config = { ...config }
        this.dis = this.isSaveDisabled()
      }
    },
    components: {
      Teleport,
      Rules
    }
  }
  </script>